export const local = 'localhost:3000';
export const dev = 'dev.getkontak.com';
export const production = "app.getkontak.com";
export const staging2 = "kontakuiprod-stage2.azurewebsites.net";
export const staging = "kontakuiprod-stage.azurewebsites.net";